import commonApi from "@/api/common/commonApi";
import { acLoginAgent, AcMode } from "@/config/config";
import instance from "@/requestConfig/intercept";
import store from "@/store";
import { ref, nextTick, computed } from "vue";
import { useRouter } from "vue-router";
// import { machineVal, NvcReject, yourRegisterRequest } from "./useNvc";
// import useManage from "../power/useManage";

interface Params {
  phone: string;
  code: string;
}
/**
 * 登录
 * @param {Object} params 参数
 * @param {Boolean} isFake 是否模拟账号登陆
 */
export default () => {
  const router = useRouter();
  const isSlidingBlock = ref<boolean>(false);

  const acMode = ref<AcMode>();

  const login = async (obj: Params, mode: AcMode = 1, nvc?: string) => {
    let params;
    acMode.value = mode;
    if (acMode.value == AcMode.AGENT) {
      // 手机号登录
      params = { ...obj, ...acLoginAgent, machineVal: "123456", username: obj.phone };
    }
    if (!params) return;
    console.log(params);

    const { access_token, data, status } = await commonApi.LoginNonTrace(params);
    if (status == 200) {
      const { userinfo } = data;
      // useManage(userinfo.userid);
      store.commit("SET_TOKEN", access_token);
      store.commit("SET_USERINFO", userinfo);
      console.log(userinfo, "userinfouserinfo");

      instance.defaults.headers["Authorization"] = "Bearer " + access_token; // 设置请求头
      // const { isPlatform } = userinfo;
      router.push("/signedCustomer");
      // if (isPlatform) router.push("/signedCustomer");
      // else router.push({ name: "manage" });
    } else {
      // await yourRegisterRequest(Number(data.statusVal)).catch((err: NvcReject) => {
      //   isSlidingBlock.value = true;
      //   return Promise.reject(err);
      // });
    }
  };

  return { login, isSlidingBlock, acMode };
};

/** 登出 */
export const logout = () => {
  const Secret = sessionStorage.getItem("Secret");
  sessionStorage.clear();
  if (Secret) {
    sessionStorage.setItem("Secret", Secret);
    window.location.replace(`${import.meta.env.VITE_BASE_PATH}?Secret=${Secret}#/login`);
  } else window.location.replace("/");
};
